import { useEffect, useState } from "react";

export const useDebouncedSearch = (delay = 300) => {
  const [searchInput, setSearchInput] = useState("");
  const [appliedSearch, setAppliedSearch] = useState("");

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setAppliedSearch(searchInput.trim());
    }, delay);

    return () => window.clearTimeout(timer);
  }, [searchInput, delay]);

  const clearSearch = () => {
    setSearchInput("");
    setAppliedSearch("");
  };

  return {
    searchInput,
    setSearchInput,
    appliedSearch,
    clearSearch,
  };
};
